// src/components/Footer.js
import React from "react";
import { Mail, Linkedin, Github, Gitlab } from "lucide-react";
import resumeData from "../data/resumeData";

const Footer = () => {
	const { personalInfo } = resumeData;

	return (
		<footer className="bg-slate-950 text-white py-14">
			<div className="container mx-auto px-6">
				<div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-6">
					<div className="text-center md:text-left">
						<h2 className="text-2xl font-bold tracking-tight mb-1">
							{personalInfo.name}
						</h2>
						<p className="text-slate-400">{personalInfo.title}</p>
					</div>
					<div className="flex gap-3">
						<a
							href={`mailto:${personalInfo.email}`}
							aria-label="Email"
							className="p-3 rounded-full border border-white/10 bg-white/5 text-slate-200 hover:bg-white/10 hover:border-white/25 hover:-translate-y-0.5 transition-all duration-300"
						>
							<Mail size={20} />
						</a>
						<a
							href={`https://${personalInfo.linkedin}`}
							target="_blank"
							rel="noopener noreferrer"
							aria-label="LinkedIn"
							className="p-3 rounded-full border border-white/10 bg-white/5 text-slate-200 hover:bg-white/10 hover:border-white/25 hover:-translate-y-0.5 transition-all duration-300"
						>
							<Linkedin size={20} />
						</a>
						<a
							href={`https://${personalInfo.github}`}
							target="_blank"
							rel="noopener noreferrer"
							aria-label="GitHub"
							className="p-3 rounded-full border border-white/10 bg-white/5 text-slate-200 hover:bg-white/10 hover:border-white/25 hover:-translate-y-0.5 transition-all duration-300"
						>
							<Github size={20} />
						</a>
						<a
							href={`https://${personalInfo.github2}`}
							target="_blank"
							rel="noopener noreferrer"
							aria-label="School GitHub"
							className="p-3 rounded-full border border-white/10 bg-white/5 text-slate-200 hover:bg-white/10 hover:border-white/25 hover:-translate-y-0.5 transition-all duration-300"
						>
							<Github size={20} />
						</a>
						<a
							href={`https://${personalInfo.gitlab}`}
							target="_blank"
							rel="noopener noreferrer"
							aria-label="GitLab"
							className="p-3 rounded-full border border-white/10 bg-white/5 text-slate-200 hover:bg-white/10 hover:border-white/25 hover:-translate-y-0.5 transition-all duration-300"
						>
							<Gitlab size={20} />
						</a>
					</div>
				</div>
				<div className="text-center border-t border-white/10 pt-8">
					<p className="text-sm text-slate-500">
						&copy; {new Date().getFullYear()} Mason DiGiorgio. All
						rights reserved.
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
